<template>
    <Bar
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="150"
    />
    <!--<Bar :chart-data="chartData" :chart-options="chartOptions" />-->

  </template>
  
  <script>
  import { Bar } from 'vue-chartjs'
  import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
  
  ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

  export default {
    name: 'BarChart',
    components: { Bar },
    props: {
      chartData: {
        type:Object,
        required:true
      },     
      chartId: {
        type: String,
        default: 'bar-chart'
      },
      datasetIdKey: {
        type: String,
        default: 'label'
      },
      width: {
        type: Number,
        default: 400
      },
      height: {
        type: Number,
        default: 150
      },
      cssClasses: {
        default: '',
        type: String
      },
      styles: {
        type: Object,
        default: () => {}
      },
      plugins: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        //chartData: {"labels":[], "datasets": []},
        //chartData: {
        //  labels: [ 'January', 'February', 'March' ],
        //  datasets: [ { data: [40, 20, 12] } ]
        //},
        chartOptions: {
            type: Object,
            default: () => {}
        },        
        chartOptions_: {
          responsive: true
        }
      }
    }
  }
  </script>